// Import model
import { StartObjectAppointmentCancelAppointmentRequest } from '../models/StartObjectAppointmentCancelAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartObjectAppointmentCancelAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartObjectAppointmentCancelAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartObjectAppointmentCancelAppointmentRequest instance
   */
  static deserialize(json: string): StartObjectAppointmentCancelAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartObjectAppointmentCancelAppointmentRequest instance
   */
  static fromObject(obj: any): StartObjectAppointmentCancelAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartObjectAppointmentCancelAppointmentRequest');
    }


    const instance: StartObjectAppointmentCancelAppointmentRequest = {
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartObjectAppointmentCancelAppointmentRequest instances
   */
  static deserializeArray(json: string): StartObjectAppointmentCancelAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartObjectAppointmentCancelAppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartObjectAppointmentCancelAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartObjectAppointmentCancelAppointmentRequest instance to a plain object
   */
  static toObject(instance: StartObjectAppointmentCancelAppointmentRequest): any {
    return {
    };
  }

  /**
   * Serializes an array of StartObjectAppointmentCancelAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartObjectAppointmentCancelAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
